(function () {
  var currentScript = document.currentScript;
  var heartFilledUrl = currentScript && currentScript.dataset.heartFilled ? currentScript.dataset.heartFilled : '';
  var heartEmptyUrl = currentScript && currentScript.dataset.heartEmpty ? currentScript.dataset.heartEmpty : '';

  if (window.location.pathname.replace(/\/$/, '') === '/apps/wishlist') return;

  var cardSelector = 'product-card, .product-card, .product-grid__card, .product-grid__item, .resource-list__item';
  var excludedContextSelector = 'wishlist-page, .wk-page, header, footer, cart-drawer, .cart-drawer, .quick-add-modal, .product-information';
  var hostSelector = 'wishlist-link, wishlist-button, wishlist-button-collection, wk-button';
  var optimisticStateDuration = 5000;
  var optimisticStates = {};
  var observedSwishStates = {};
  var wishlistSnapshot = null;
  var wishlistSnapshotPromise = null;
  var controlSelector = [
    'wishlist-link',
    'wishlist-button',
    'wishlist-button-collection',
    'wishlist-link .wk-button',
    'wishlist-button .wk-button',
    'wishlist-button-collection .wk-button',
    'wishlist-link button',
    'wishlist-link a',
    'wishlist-button button',
    'wishlist-button a',
    'wishlist-button-collection button',
    'wishlist-button-collection a',
    'wk-button',
    'wk-button .wk-button',
    'wk-button button',
    'wk-button a',
    '.wk-button',
    'button[class*="wishlist"]',
    'a[class*="wishlist"]',
    '[role="button"][class*="wishlist"]',
    'button[aria-label*="wishlist"]',
    'a[aria-label*="wishlist"]',
    '[role="button"][aria-label*="wishlist"]',
    'button[aria-label*="Wishlist"]',
    'a[aria-label*="Wishlist"]',
    '[role="button"][aria-label*="Wishlist"]',
    'button[aria-label*="favourite"]',
    'a[aria-label*="favourite"]',
    '[role="button"][aria-label*="favourite"]',
    'button[aria-label*="favorite"]',
    'a[aria-label*="favorite"]',
    '[role="button"][aria-label*="favorite"]',
    'button',
    'a[role="button"]',
    '[role="button"]'
  ].join(',');
  var scheduled = false;

  function getText(element) {
    return element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getClosestHost(element) {
    return element.closest(hostSelector);
  }

  function getAttributeHints(element) {
    if (!element || !element.attributes) return '';

    return Array.prototype.map
      .call(element.attributes, function (attribute) {
        if (attribute.name.indexOf('data-nobo-product-wishlist') === 0) return '';
        if (attribute.name === 'style') return '';

        return attribute.name + '=' + attribute.value;
      })
      .filter(Boolean)
      .join(' ');
  }

  function getHints(element) {
    var wishlistHost = getClosestHost(element);
    var control = getInteractiveControl(element);
    var card = getProductCardContext(element);
    var stateElement = element.querySelector(
      '[aria-pressed], [aria-checked], [data-status], [data-state], [data-wk-state], [data-wishlist-state], [class*="active"], [class*="added"], [class*="selected"], [class*="remove"], [class*="saved"]'
    );

    return [
      element.tagName,
      element.getAttribute('class'),
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('data-action'),
      element.getAttribute('data-product-id'),
      element.getAttribute('data-product-handle'),
      element.getAttribute('product-id'),
      element.getAttribute('handle'),
      element.getAttribute('data-status'),
      element.getAttribute('data-state'),
      element.getAttribute('data-wk-state'),
      element.getAttribute('data-wishlist-state'),
      wishlistHost && wishlistHost.getAttribute('class'),
      wishlistHost && wishlistHost.getAttribute('aria-label'),
      wishlistHost && wishlistHost.getAttribute('title'),
      wishlistHost && wishlistHost.getAttribute('data-action'),
      wishlistHost && wishlistHost.getAttribute('data-product-id'),
      wishlistHost && wishlistHost.getAttribute('data-product-handle'),
      wishlistHost && wishlistHost.getAttribute('product-id'),
      wishlistHost && wishlistHost.getAttribute('handle'),
      wishlistHost && wishlistHost.getAttribute('data-status'),
      wishlistHost && wishlistHost.getAttribute('data-state'),
      wishlistHost && wishlistHost.getAttribute('data-wk-state'),
      wishlistHost && wishlistHost.getAttribute('data-wishlist-state'),
      control && control.getAttribute('class'),
      control && control.getAttribute('aria-label'),
      control && control.getAttribute('title'),
      control && control.getAttribute('data-action'),
      control && control.getAttribute('data-status'),
      control && control.getAttribute('data-state'),
      control && control.getAttribute('data-wk-state'),
      control && control.getAttribute('data-wishlist-state'),
      stateElement && stateElement.getAttribute('class'),
      stateElement && stateElement.getAttribute('aria-label'),
      stateElement && stateElement.getAttribute('title'),
      stateElement && stateElement.getAttribute('data-action'),
      stateElement && stateElement.getAttribute('data-status'),
      stateElement && stateElement.getAttribute('data-state'),
      stateElement && stateElement.getAttribute('data-wk-state'),
      stateElement && stateElement.getAttribute('data-wishlist-state'),
      card && card.getAttribute('class'),
      card && card.getAttribute('data-status'),
      card && card.getAttribute('data-state'),
      card && card.getAttribute('data-wk-state'),
      card && card.getAttribute('data-wishlist-state'),
      getAttributeHints(element),
      getAttributeHints(wishlistHost),
      getAttributeHints(control),
      getAttributeHints(stateElement),
      getAttributeHints(card)
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  function getProductCardContext(element) {
    var card = element.closest(cardSelector);
    if (card) return card;

    var parent = element.parentElement;
    var depth = 0;

    while (parent && parent !== document.body && depth < 6) {
      if (parent.querySelector('a[href*="/products/"], product-card, .product-card__link, .card-gallery')) return parent;

      parent = parent.parentElement;
      depth += 1;
    }

    return null;
  }

  function getProductKeys(element) {
    var control = getInteractiveControl(element);
    var host = getWishlistHost(element, control);
    var card = getProductCardContext(element);
    var keys = [];
    var candidates = [
      element,
      control,
      host,
      card,
      element.closest('[data-product-id], [data-product-handle], [product-id], [handle]'),
      control.closest('[data-product-id], [data-product-handle], [product-id], [handle]')
    ];

    function addKey(type, value) {
      var key;

      if (!value) return;

      key = type + ':' + value;
      if (keys.indexOf(key) === -1) {
        keys.push(key);
      }
    }

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];

      if (!candidate) continue;

      addKey('id', candidate.getAttribute('data-product-id') || candidate.getAttribute('product-id'));
      addKey('handle', candidate.getAttribute('data-product-handle') || candidate.getAttribute('handle'));
    }

    var productLink = card && card.querySelector('a[href*="/products/"]');
    if (!productLink) return keys;

    try {
      var url = new URL(productLink.getAttribute('href'), window.location.origin);
      var handleMatch = url.pathname.match(/\/products\/([^/?#]+)/);

      if (handleMatch) {
        addKey('handle', handleMatch[1]);
      }
    } catch (error) {
      return keys;
    }

    return keys;
  }

  function getProductKey(element) {
    return getProductKeys(element)[0] || '';
  }

  function normalizeProductKeys(productKeys) {
    if (!productKeys) return [];

    return Array.isArray(productKeys) ? productKeys : [productKeys];
  }

  function getOptimisticState(productKeys) {
    var keys = normalizeProductKeys(productKeys);
    var state;

    for (var index = 0; index < keys.length; index += 1) {
      state = optimisticStates[keys[index]];

      if (!state) continue;

      if (state.expiresAt < Date.now()) {
        delete optimisticStates[keys[index]];
        continue;
      }

      return state.value;
    }

    return '';
  }

  function setOptimisticState(productKeys, state) {
    var keys = normalizeProductKeys(productKeys);

    if (!keys.length) return;

    keys.forEach(function (key) {
      optimisticStates[key] = {
        value: state,
        expiresAt: Date.now() + optimisticStateDuration
      };
    });
  }

  function getObservedSwishState(productKeys) {
    var keys = normalizeProductKeys(productKeys);
    var state;

    for (var index = 0; index < keys.length; index += 1) {
      state = observedSwishStates[keys[index]];

      if (state) {
        return state;
      }
    }

    return '';
  }

  function setObservedSwishState(productKeys, state) {
    var keys = normalizeProductKeys(productKeys);

    if (!keys.length) return;

    keys.forEach(function (key) {
      observedSwishStates[key] = state;
    });
  }

  function addKey(keys, type, value) {
    var key;

    if (!value) return;

    key = type + ':' + value;
    if (keys.indexOf(key) === -1) {
      keys.push(key);
    }
  }

  function getWishlistSnapshotUrl() {
    var url = new URL('/apps/wishlist', window.location.origin);

    url.searchParams.set('_nobo_wishlist_state', Date.now().toString());

    return url.href;
  }

  function getWishlistSnapshotRoot(documentFragment) {
    return documentFragment.querySelector('wishlist-page') || documentFragment.querySelector('.wk-page');
  }

  function extractWishlistSnapshotKeysFromRoot(root) {
    var keys = [];

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-product-id], [data-wk-product-id], [product-id], [data-product-handle], [handle], a[href*="/products/"]'),
      function (element) {
        if (element.closest('header, footer, cart-drawer, .cart-drawer, .quick-add-modal, .predictive-search')) return;

        addKey(keys, 'id', element.getAttribute('data-product-id') || element.getAttribute('data-wk-product-id') || element.getAttribute('product-id'));
        addKey(keys, 'handle', element.getAttribute('data-product-handle') || element.getAttribute('handle'));

        if (element.matches('a[href*="/products/"]')) {
          try {
            var url = new URL(element.getAttribute('href'), window.location.origin);
            var handleMatch = url.pathname.match(/\/products\/([^/?#]+)/);

            if (handleMatch) {
              addKey(keys, 'handle', handleMatch[1]);
            }
          } catch (error) {
            // Ignore malformed links from third-party markup.
          }
        }
      }
    );

    return keys;
  }

  function extractWishlistSnapshotKeys(html) {
    var documentFragment = new DOMParser().parseFromString(html, 'text/html');
    var root = getWishlistSnapshotRoot(documentFragment);

    if (!root) return null;

    return extractWishlistSnapshotKeysFromRoot(root);
  }

  function extractHandleFromUrl(value) {
    var handleMatch;

    if (typeof value !== 'string' || value.indexOf('/products/') === -1) return '';

    try {
      handleMatch = new URL(value, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
    } catch (error) {
      handleMatch = value.match(/\/products\/([^/?#]+)/);
    }

    return handleMatch ? handleMatch[1] : '';
  }

  function extractIdFromGid(value) {
    var match;

    if (typeof value !== 'string') return '';

    match = value.match(/gid:\/\/shopify\/Product\/(\d+)/);

    return match ? match[1] : '';
  }

  function collectSwishItemKeys(value, keys, parentKey) {
    if (!value) return;

    if (typeof value === 'string') {
      addKey(keys, 'handle', extractHandleFromUrl(value));
      addKey(keys, 'id', extractIdFromGid(value));
      return;
    }

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        collectSwishItemKeys(item, keys, parentKey);
      });
      return;
    }

    if (typeof value !== 'object') return;

    Object.keys(value).forEach(function (key) {
      var child = value[key];
      var normalizedKey = key.toLowerCase();
      var isProductContext = parentKey === 'product' || normalizedKey.indexOf('product') !== -1;

      if (normalizedKey === 'producthandle' || normalizedKey === 'product_handle') {
        addKey(keys, 'handle', child);
      }

      if (normalizedKey === 'handle' && (isProductContext || value.productId || value.product_id || value.productGid || value.product_gid)) {
        addKey(keys, 'handle', child);
      }

      if (normalizedKey === 'productid' || normalizedKey === 'product_id') {
        addKey(keys, 'id', child);
      }

      if (normalizedKey === 'id' && parentKey === 'product') {
        addKey(keys, 'id', child);
      }

      addKey(keys, 'handle', extractHandleFromUrl(child));
      addKey(keys, 'id', extractIdFromGid(child));
      collectSwishItemKeys(child, keys, normalizedKey);
    });
  }

  function extractSwishSnapshotKeys(response) {
    var keys = [];
    var payload = response && typeof response === 'object' && 'data' in response ? response.data : response;

    collectSwishItemKeys(payload, keys, '');

    return keys;
  }

  function requestWishlistSnapshotSwish() {
    if (!window.Promise || !('noModule' in document.createElement('script'))) {
      return Promise.reject(new Error('Swish module unsupported'));
    }

    return import('/apps/wishlist/assets/swish.js')
      .then(function (module) {
        if (!module || typeof module.swishApp !== 'function') throw new Error('Swish app unavailable');

        return module.swishApp({
          proxy: {
            baseUrl: '/apps/wishlist'
          }
        });
      })
      .then(function (swish) {
        if (!swish || !swish.api || !swish.api.items || typeof swish.api.items.list !== 'function') {
          throw new Error('Swish items API unavailable');
        }

        return swish.api.items.list();
      })
      .then(extractSwishSnapshotKeys);
  }

  function requestWishlistSnapshotFrame() {
    return new Promise(function (resolve, reject) {
      var iframe = document.createElement('iframe');
      var resolved = false;
      var timeoutId;

      function cleanup() {
        window.clearTimeout(timeoutId);
        iframe.removeEventListener('load', onLoad);
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }

      function finish(value) {
        if (resolved) return;

        resolved = true;
        cleanup();
        resolve(value);
      }

      function fail() {
        if (resolved) return;

        resolved = true;
        cleanup();
        reject(new Error('Wishlist snapshot failed'));
      }

      function readFrame() {
        var frameDocument = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        var root = frameDocument && getWishlistSnapshotRoot(frameDocument);

        if (!root) {
          fail();
          return;
        }

        finish(extractWishlistSnapshotKeysFromRoot(root));
      }

      function onLoad() {
        window.setTimeout(readFrame, 2500);
      }

      timeoutId = window.setTimeout(fail, 8000);
      iframe.addEventListener('load', onLoad);
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.src = getWishlistSnapshotUrl();
      iframe.style.cssText = 'position:fixed;width:1px;height:1px;left:-9999px;top:-9999px;opacity:0;pointer-events:none;border:0;';
      document.body.appendChild(iframe);
    });
  }

  function requestWishlistSnapshot(force) {
    if (force) {
      wishlistSnapshot = null;
      wishlistSnapshotPromise = null;
    }

    if (wishlistSnapshot) {
      return Promise.resolve(wishlistSnapshot);
    }

    if (wishlistSnapshotPromise) {
      return wishlistSnapshotPromise;
    }

    wishlistSnapshotPromise = requestWishlistSnapshotSwish()
      .catch(requestWishlistSnapshotFrame)
      .then(function (wishlistKeys) {
        wishlistSnapshot = wishlistKeys;
        wishlistSnapshotPromise = null;

        return wishlistSnapshot;
      })
      .catch(function () {
        wishlistSnapshotPromise = null;

        return null;
      });

    return wishlistSnapshotPromise;
  }

  function productKeysContain(productKeys, wishlistKeys) {
    var keys = normalizeProductKeys(productKeys);

    return keys.some(function (key) {
      return wishlistKeys.indexOf(key) !== -1;
    });
  }

  function getSwishElementState(element) {
    var control = getInteractiveControl(element);
    var host = getWishlistHost(element, control);
    var wkButton = element.closest('wk-button') || control.closest('wk-button') || (host && host.querySelector('wk-button'));
    var elements = [element, control, host, wkButton];
    var index;

    for (index = 0; index < elements.length; index += 1) {
      var candidate = elements[index];

      if (!candidate) continue;

      if (candidate.productInfo && typeof candidate.productInfo.inWishlist === 'boolean') {
        return candidate.productInfo.inWishlist ? 'active' : 'inactive';
      }

      if (candidate.tagName === 'WK-BUTTON' && typeof candidate.selected === 'boolean') {
        return candidate.selected ? 'active' : 'inactive';
      }

      if (candidate.tagName === 'WK-BUTTON' && candidate.hasAttribute && candidate.hasAttribute('selected')) {
        return 'active';
      }

      if (candidate.getAttribute && candidate.getAttribute('aria-selected') === 'true') {
        return 'active';
      }

      if (candidate.getAttribute && candidate.getAttribute('aria-selected') === 'false') {
        return 'inactive';
      }
    }

    return '';
  }

  function hasNativeActiveState(element) {
    var hints = getHints(element);
    var text = getText(element);

    return (
      element.getAttribute('aria-pressed') === 'true' ||
      element.getAttribute('aria-checked') === 'true' ||
      /\b(data-[\w-]*(added|selected|active|saved|wishlist|favourite|favorite|status|state)=(true|1|yes|active|added|selected|saved|remove|in-wishlist))\b/.test(hints) ||
      /\b(wk-button--remove|wk-button--added|wk-button--selected|wk-selected|wk-active|remove|removed|selected|added|saved|in-wishlist|wishlist--active|wishlist-active|is-active|status-added|state-added)\b/.test(hints) ||
      hints.indexOf('remove from wishlist') !== -1 ||
      hints.indexOf('remove from favourites') !== -1 ||
      hints.indexOf('remove from favorites') !== -1 ||
      hints.indexOf('added to wishlist') !== -1 ||
      hints.indexOf('added to favourites') !== -1 ||
      hints.indexOf('added to favorites') !== -1 ||
      hints.indexOf('in wishlist') !== -1 ||
      hints.indexOf('in favourites') !== -1 ||
      hints.indexOf('in favorites') !== -1 ||
      text.indexOf('remove') !== -1 ||
      text.indexOf('quitar') !== -1 ||
      text.indexOf('eliminar') !== -1 ||
      text.indexOf('saved') !== -1
    );
  }

  function hasNativeInactiveState(element) {
    var hints = getHints(element);
    var text = getText(element);

    return (
      element.getAttribute('aria-pressed') === 'false' ||
      element.getAttribute('aria-checked') === 'false' ||
      /\b(wk-button--add|wk-button--default|wk-button--empty|wk-empty|add|add-to-wishlist|not-in-wishlist|wishlist--inactive|is-inactive)\b/.test(hints) ||
      text.indexOf('add to wishlist') !== -1 ||
      text.indexOf('add to favourites') !== -1 ||
      text.indexOf('add to favorites') !== -1 ||
      text.indexOf('añadir') !== -1 ||
      text.indexOf('agregar') !== -1
    );
  }

  function getWishlistState(element) {
    var productKeys = getProductKeys(element);
    var optimisticState;
    var observedSwishState;
    var swishElementState;

    optimisticState = getOptimisticState(productKeys);
    if (optimisticState) {
      return optimisticState;
    }

    if (wishlistSnapshot !== null && productKeys.length) {
      return productKeysContain(productKeys, wishlistSnapshot) ? 'active' : 'inactive';
    }

    observedSwishState = getObservedSwishState(productKeys);
    if (observedSwishState) {
      return observedSwishState;
    }

    swishElementState = getSwishElementState(element);

    if (swishElementState) {
      return swishElementState;
    }

    if (hasNativeActiveState(element)) {
      return 'active';
    }

    if (hasNativeInactiveState(element)) {
      return 'inactive';
    }

    return 'inactive';
  }

  function getInteractiveControl(element) {
    if (element.matches('button, a, [role="button"]')) return element;

    return element.querySelector('a.wk-button, button.wk-button, button, a, [role="button"]') || element;
  }

  function getWishlistHost(element, control) {
    return (
      element.closest(hostSelector) ||
      control.closest(hostSelector)
    );
  }

  function getProductHandleValue(element) {
    var control = getInteractiveControl(element);
    var host = getWishlistHost(element, control);
    var card = getProductCardContext(element);
    var candidates = [
      element,
      control,
      host,
      card,
      element.closest('[data-product-handle], [handle]'),
      control.closest('[data-product-handle], [handle]')
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      var handle;

      if (!candidate) continue;

      handle = candidate.getAttribute('data-product-handle') || candidate.getAttribute('handle');
      if (handle) return handle;
    }

    var productLink = card && card.querySelector('a[href*="/products/"]');
    if (!productLink) return '';

    try {
      var url = new URL(productLink.getAttribute('href'), window.location.origin);
      var handleMatch = url.pathname.match(/\/products\/([^/?#]+)/);

      return handleMatch ? handleMatch[1] : '';
    } catch (error) {
      return '';
    }
  }

  function getProductVariantIdValue(element) {
    var control = getInteractiveControl(element);
    var host = getWishlistHost(element, control);
    var candidates = [element, control, host];
    var variantId;
    var parsedVariantId;

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];

      if (!candidate) continue;

      variantId = candidate.getAttribute('data-variant-id') || candidate.getAttribute('variant-id');
      if (variantId) break;
    }

    if (!variantId) return undefined;

    parsedVariantId = parseInt(variantId, 10);

    return Number.isNaN(parsedVariantId) ? variantId : parsedVariantId;
  }

  function bindSwishObservedState(control, sourceElement) {
    var productHandle;
    var variantId;
    var productKeys;

    if (control.getAttribute('data-nobo-product-wishlist-swish-bound') === 'true') return;

    productHandle = getProductHandleValue(sourceElement || control);
    if (!productHandle) return;

    control.setAttribute('data-nobo-product-wishlist-swish-bound', 'true');
    variantId = getProductVariantIdValue(sourceElement || control);
    productKeys = getProductKeys(sourceElement || control);

    function subscribeToSwish() {
      var app = window.WishlistKing;
      var subscription;

      if (control.getAttribute('data-nobo-product-wishlist-swish-subscribed') === 'true') return true;
      if (!app || !app.state || typeof app.state.observeProductInfo !== 'function') return false;

      try {
        subscription = app.state.observeProductInfo({
          productHandle: productHandle,
          variantId: variantId
        }).subscribe(function (productInfo) {
          var state = productInfo && productInfo.inWishlist ? 'active' : 'inactive';

          setObservedSwishState(productKeys, state);
          setWishlistState(control, sourceElement || control, state, false);
        });

        control.setAttribute('data-nobo-product-wishlist-swish-subscribed', 'true');

        if (subscription && typeof subscription.unsubscribe === 'function') {
          control.noboWishlistSubscription = subscription;
        }

        return true;
      } catch (error) {
        return false;
      }
    }

    if (subscribeToSwish()) return;

    document.addEventListener('wk:app:ready', subscribeToSwish, { once: true });
    window.setTimeout(subscribeToSwish, 1000);
    window.setTimeout(subscribeToSwish, 3000);
    window.setTimeout(subscribeToSwish, 6000);
  }

  function hasProductHints(element) {
    var hints = getHints(element);

    return (
      hints.indexOf('data-product') !== -1 ||
      hints.indexOf('product-id') !== -1 ||
      Boolean(element.getAttribute('data-product-id')) ||
      Boolean(element.getAttribute('data-product-handle')) ||
      Boolean(element.getAttribute('product-id')) ||
      Boolean(element.getAttribute('handle'))
    );
  }

  function isProductWishlistControl(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (element.closest(excludedContextSelector)) return false;
    if (!element.matches('button, a, [role="button"]')) return false;

    var hints = getHints(element);
    var text = getText(element);
    var isWishlistControl =
      element.closest('wishlist-link, wishlist-button, wishlist-button-collection, wk-button') ||
      hints.indexOf('wk-button') !== -1 ||
      hints.indexOf('wishlist') !== -1 ||
      hints.indexOf('favourite') !== -1 ||
      hints.indexOf('favorite') !== -1 ||
      text.indexOf('wishlist') !== -1 ||
      text.indexOf('favourite') !== -1 ||
      text.indexOf('favorite') !== -1;

    if (!isWishlistControl) return false;

    return Boolean(getProductCardContext(element) || hasProductHints(element));
  }

  function updateIcon(control, state) {
    var iconUrl = state === 'active' ? heartFilledUrl : heartEmptyUrl;
    if (!iconUrl) return;

    control.style.setProperty('--nobo-product-wishlist-icon', 'url("' + iconUrl + '")');
  }

  function setWishlistState(control, sourceElement, state, persist) {
    var productKeys = getProductKeys(sourceElement || control);

    updateIcon(control, state);

    if (control.getAttribute('data-nobo-product-wishlist-state') !== state) {
      control.setAttribute('data-nobo-product-wishlist-state', state);
    }

    if (persist) {
      setOptimisticState(productKeys, state);
    }
  }

  function bindHoverState(control, sourceElement) {
    if (control.getAttribute('data-nobo-product-wishlist-hover-bound') === 'true') return;

    var card = getProductCardContext(sourceElement);
    if (!card) return;

    control.setAttribute('data-nobo-product-wishlist-hover-bound', 'true');

    card.addEventListener('pointerenter', function () {
      control.setAttribute('data-nobo-product-wishlist-hover', 'true');
    });

    card.addEventListener('pointerleave', function () {
      control.removeAttribute('data-nobo-product-wishlist-hover');
    });

    card.addEventListener('focusin', function () {
      control.setAttribute('data-nobo-product-wishlist-hover', 'true');
    });

    card.addEventListener('focusout', function () {
      control.removeAttribute('data-nobo-product-wishlist-hover');
    });
  }

  function decorateControl(element) {
    var control = getInteractiveControl(element);
    var state = getWishlistState(element);
    var host = getWishlistHost(element, control);

    if (host && host !== control) {
      host.classList.add('nobo-product-wishlist-host');
    }

    control.classList.add('nobo-product-wishlist-button');
    bindHoverState(control, element);
    setWishlistState(control, element, state, false);
    bindSwishObservedState(control, element);
  }

  function syncWishlistControls() {
    Array.prototype.forEach.call(document.querySelectorAll(controlSelector), function (element) {
      if (isProductWishlistControl(element)) {
        decorateControl(element);
      }
    });
  }

  function applyWishlistSnapshot(wishlistKeys) {
    Array.prototype.forEach.call(document.querySelectorAll('.nobo-product-wishlist-button'), function (control) {
      var productKeys = getProductKeys(control);
      var snapshotState;

      if (!productKeys.length) return;

      snapshotState = productKeysContain(productKeys, wishlistKeys) ? 'active' : 'inactive';

      // A refreshed wishlist is the confirmed state. Keep the local Swish cache
      // aligned so an old subscription value cannot restore the previous icon.
      setObservedSwishState(productKeys, snapshotState);

      setWishlistState(
        control,
        control,
        snapshotState,
        false
      );
    });
  }

  function scheduleSync() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      syncWishlistControls();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('load', scheduleSync);
  window.setTimeout(scheduleSync, 500);
  window.setTimeout(scheduleSync, 1500);
  window.setTimeout(scheduleSync, 3000);
  window.setTimeout(scheduleSync, 6000);
  requestWishlistSnapshot(false).then(function (wishlistKeys) {
    if (wishlistKeys) applyWishlistSnapshot(wishlistKeys);
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var control = event.target.closest('.nobo-product-wishlist-button');
    if (!control) return;

    var currentState = control.getAttribute('data-nobo-product-wishlist-state');
    var nextState = currentState === 'active' ? 'inactive' : 'active';

    setWishlistState(control, control, nextState, true);
    window.setTimeout(scheduleSync, 0);
    window.setTimeout(scheduleSync, 250);
    window.setTimeout(scheduleSync, 1000);
    window.setTimeout(function () {
      requestWishlistSnapshot(true).then(function (wishlistKeys) {
        if (wishlistKeys) applyWishlistSnapshot(wishlistKeys);
      });
    }, 1500);
    window.setTimeout(function () {
      requestWishlistSnapshot(true).then(function (wishlistKeys) {
        if (wishlistKeys) applyWishlistSnapshot(wishlistKeys);
      });
    }, 4000);
  });

  var observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [
      'aria-checked',
      'aria-label',
      'aria-pressed',
      'class',
      'data-product-handle',
      'data-product-id',
      'data-state',
      'data-status',
      'data-wishlist-state',
      'data-wk-state',
      'handle',
      'product-id',
      'title'
    ],
    childList: true,
    subtree: true
  });
})();
